import { Plugin } from 'vue'
import featureDetection from './features'
import getBrowser from './features/browser'

export interface IDeviceInfo {
  getBrowser: ReturnType<typeof getBrowser>
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $deviceInfo: IDeviceInfo
  }
}

export default {
  install(app) {
    app.config.globalProperties.$deviceInfo = featureDetection
  },
} as Plugin
